import { isPlainObject } from 'lodash'
const IM_MAIN_LAYOUT_WIDTH = 'IM_MAIN_LAYOUT_WIDTH'
const IM_INPUT_CONTENT = 'IM_INPUT_CONTENT'
const IM_SOP_MESSAGE_LOG = 'IM_SOP_MESSAGE_LOG'
const IM_CONVERSATION_SOP_STATE = 'IM_CONVERSATION_SOP_STATE'

/**
 * 获取缓存IM容器宽度
 * @returns {string}
 */
export const getImMainWidth = () => {
  try {
    return window.localStorage.getItem(IM_MAIN_LAYOUT_WIDTH)
  } catch (e) {
    console.error(e)
  }
}

/**
 * 缓存IM容器宽度
 * @param width {string} 宽度
 */
export const setImMainWidth = width => {
  try {
    window.localStorage.setItem(IM_MAIN_LAYOUT_WIDTH, width)
  } catch (e) {
    console.error(e)
  }
}

/**
 * 获取IM输入内容缓存
 */
export const getImInputContentByCache = conversationId => {
  try {
    const map = JSON.parse(window.localStorage.getItem(IM_INPUT_CONTENT)) || {}
    // conversationId存在返回当前，否则返回所有
    if (conversationId) {
      return Array.isArray(map[conversationId]) ? map[conversationId] : []
    }
    return map || {}
  } catch (e) {
    console.error(e)
    return []
  }
}

/**
 * 设置IM输入内容缓存
 * @param conversationId {string}
 * @param content {array}
 */
export const setImInputContentByCache = (conversationId, content) => {
  try {
    if (!Array.isArray(content)) content = [content]
    let allMap = getImInputContentByCache()
    if (!allMap) allMap = {}
    // 无内容则清除
    if (!content || !content.length) {
      delete allMap[conversationId]
    } else {
      allMap[conversationId] = content
    }
    window.localStorage.setItem(IM_INPUT_CONTENT, JSON.stringify(allMap))
  } catch (e) {
    console.error(e)
  }
}

/**
 * 获取IM输入内容缓存
 */
export const clearImInputContentByCache = conversationId => {
  try {
    const allMap = getImInputContentByCache()
    if (!allMap) return
    if (allMap?.hasOwnProperty(conversationId)) delete allMap[conversationId]
    window.localStorage.setItem(IM_INPUT_CONTENT, JSON.stringify(allMap))
  } catch (e) {
    console.error(e)
  }
}

/**
 * sop-设置im消息解析日志
 * 为何要缓存，请看 https://wiki.amh-group.com/pages/viewpage.action?pageId=271085972
 * @param log {object} 解析日志
 */
export const setImSopPostMsgLog = log => {
  try {
    if (!isPlainObject(log)) return
    let logArr = getImSopPostMsgLog()
    // 删除历史日志
    if (logArr.length > 1000) logArr = logArr.slice(0, 1000)
    logArr.unshift(JSON.stringify(log))
    window.localStorage.setItem(IM_SOP_MESSAGE_LOG, JSON.stringify(logArr))
  } catch (e) {
    console.error(e)
  }
}

/**
 * sop-获取im消息解析日志
 */
export const getImSopPostMsgLog = () => {
  try {
    const logArr = JSON.parse(window.localStorage.getItem(IM_SOP_MESSAGE_LOG)) || []
    // conversationId存在返回当前，否则返回所有
    return Array.isArray(logArr) ? logArr : []
  } catch (e) {
    return null
  }
}

/**
 * 是否已经解析im消息
 * @param log {object} 日志消息
 * @returns {boolean}
 */
export const hasExistImSopPostMsgLog = log => {
  const logString = JSON.stringify(log)
  const logArr = getImSopPostMsgLog()
  return logArr.includes(logString)
}

/**
 * 获取会话SOP选择缓存
 * @param conversationId {string}
 */
export const getImConversationSopState = conversationId => {
  try {
    const map = JSON.parse(window.localStorage.getItem(IM_CONVERSATION_SOP_STATE)) || {}
    if (!conversationId) return isPlainObject(map) ? map : {}
    return isPlainObject(map[conversationId]) ? map[conversationId] : {}
  } catch (e) {
    console.error(e)
    return {}
  }
}

/**
 * 设置会话SOP选择缓存
 * @param conversationId {string}
 * @param state {object}
 */
export const setImConversationSopState = (conversationId, state = {}) => {
  try {
    if (!conversationId || !isPlainObject(state)) return
    const allMap = getImConversationSopState()
    allMap[conversationId] = {
      ...(isPlainObject(allMap[conversationId]) ? allMap[conversationId] : {}),
      ...state
    }
    window.localStorage.setItem(IM_CONVERSATION_SOP_STATE, JSON.stringify(allMap))
  } catch (e) {
    console.error(e)
  }
}
